<template>
  <div class="grid flex justify-content-center mt-2 p-1 scalein animation-duration-500">
    <div class="md:col-12 sm:col-12 lg:col-10">
      <div class="grid flex lg:justify-content-center mt-2">
        <div :class="IsValid ? 'lg:col-5 md:col-12 sm:col-12' : 'lg:col-4 md:col-12 sm:col-12'">
          <div class="w-full">
            <div class="grid">
              <div class="col-12">
                <Card class="p-1  border-round shadow-1">
                  <div class="col-12">
                    <Message :severity="Msg.Severity" class="w-full" :sticky="true" :closable="false"> {{ Msg.Content }}</Message>
                  </div>
                  <template #title>
                    <div class="text-xl text-500 mb-1">Create Your New Password</div>
                  </template>
                  <template #content>
                  <div v-if="IsValid">
                    <div class="col-12">
                      <Password v-model="state.Password" :feedback="false" class="w-full" @input="v$.Password.$validate();" toggleMask />
                      <ul id="Summary" style="list-style:none" class="mt-3 p-0">
                        <li v-for="(item, index) in ValidationSummaryPanel" v-bind:key="index" class="p-0 m-0">
                          <i :class="item.Valid ? 'pi pi-check mr-2 text-success' : 'pi pi-times mr-2 text-danger'" style="font-size:1rem;"></i>
                          <span>{{item.Text}}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 flex md:justify-content-end">
                      <Button type="button"  id="Submit" :label="BtnText" icon="pi pi-arrow-circle-right" iconPos="right" :loading="Resetting"  @click="resetPassword" class="w-100 bg-orange-600" :disabled="v$.$invalid"/>
                    </div>
                    <Divider />
                    <div class="flex align-items-center justify-content-between mb-6">
                      <div class="flex align-items-center">
                        <Button type="button" label="Cancel" icon="pi pi-ban" iconPos="right"  @click="RouteTo('/')" class="w-100 bg-red-700 border" style="border-color:none"/>
                      </div>
                      <div class="flex align-items-center mt-2">
                        <span> <label>Remember your password? </label>  
                        <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer" @click="RouteTo('/LoginHome')">Login here</a></span>
                      </div>
                    </div>
                    </div>
                  <div v-else>
                    <div class="col-12">
                      <Message severity="error">For Your Security This Link Has Expired  </Message>
                      <Divider />
                      <div class="flex align-items-center justify-content-between mb-6">
                          <Button type="button" label="Resend Password Reset Link" icon="pi pi-arrow-circle-right" iconPos="right" @click="RouteTo('/ForgotPassword')" class="w-100 bg-bluegray-700 border-bluegray-700 "  />
                       
                        </div>
                      </div>
                    </div>
                  </template>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--disabled="v$.$invalid || Resetting"-->

  <Toast />
</template>

<style>
  .p-password-input {
    width: 100%
  }


  #Submit{
    color: white;
    background: #ef7d1a !important;
    border-color: #ef7d1a;
  }
</style>


<script>
  import useVuelidate from '@vuelidate/core'
  import { required, helpers } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'

    // eslint-disable-next-line no-unused-vars

  const ValidationSummary = [{
    Text: 'Password Must Contain 1 Lowercase Character',
    Valid: false,
    RegEx: "^(?=.*[a-z])"
  },
  {
    Text: 'Password Must Contain 1 Uppercase Character',
    Valid: false,
    RegEx: "^(?=.*[A-Z])"
  },
  {
    Text: 'Password Must Contain 1 Special Character',
    Valid: false,
    RegEx: "^(?=.*[!@#$%^&*])"
  },
  {
    Text: 'Password Must Contain 1 Numeric Character',
    Valid: false,
    RegEx: "^(?=.*[0-9])"
  },
  {
    Text: 'Password Must Be At Least 8 Characters Long',
    Valid: false,
    RegEx: "(?=.{8,})"
  }];

  const isPwValid = () => ValidationSummary.filter(c => c.Valid).length == 5;

  export default {
    emits: ["set-nav"],
   
    setup() {
      const state = reactive({
        Password: ''
      })
      const rules = computed(() => {
        return {
          Password: { required: helpers.withMessage("You Must Specify A Password", required), isPwValid: helpers.withMessage("Password Must Meet All Requirements", isPwValid)}
        }
      });

      const v$ = useVuelidate(rules, state)
      return { state, v$ }
    }, watch: {
      "state.Password": {
        handler() {
          for (var i = 0; i < ValidationSummary.length; i++) {
            ValidationSummary[i].Valid = this.IsValidExpression(this.state.Password, ValidationSummary[i].RegEx)
          }
          }
        },
        deep: true
    },
    data() {
    return {
        IsValid:null,
        BtnText:"Update",
        NewPassword: "",
        password: "",
        confirmPassword: "",
        Resetting: false,
        ValidationSummaryPanel: ValidationSummary
      }
    },
    created() {
      this.$emit("set-nav", this.$route)
      var self = this;
      self.$http.post('/Authorization/ValidateToken', {
        UserName: self.$route.query.User,
        Token: self.$route.query.token,
      }).then(function (response) {
        // eslint-disable-next-line no-debugger
        if (!response.data.isValid) {
          self.IsValid = false;
        }
        else {
          self.IsValid = true;
        }
      })
    },
    methods: {
      resetPassword() {
        this.Resetting = true;
        this.BtnText = "Updating..."
        var self = this;

        self.$http.post('/Authorization/ResetPassword', {
          UserName: self.$route.query.User,
          Token: self.$route.query.token,
          Password: self.state.Password
        }).then(function (response) {

          // eslint-disable-next-line no-debugger
          if (response.data.success) {
              self.stateData = {
                token: response.data.tokenization.token,
                userName: self.userName,
                isAuthenticated: true,
                role: response.data.role,
                organizationId: response.data.organizationId,
                id: response.data.id
              };
              self.$store.commit('SetAuth', self.stateData);
              var homePage = self.$store.getters.user.homepage;
              self.$router.push({ path: homePage })
            }
          else {
            self.$toast.add({ severity: 'error', summary: 'Password Reset Request', detail: 'Error resetting your password, please contact support', life: 3000,  position:"top-center"});
            self.BtnText = "Update Password"
            self.Resetting = false;
            self.state.Password = '';
          }
        })
      },
      RouteTo(path) {
        this.$router.push({ path: path })
      },
      IsValidExpression(pw, regex) {
        var regexExpression = new RegExp(regex);
        return regexExpression.test(pw)
      },
      validateRequirements() {
        for (var i = 0; i < ValidationSummary.length; i++) {
            ValidationSummary[i].Valid = this.IsValidExpression(this.state.Password, ValidationSummary[i].RegEx)
        }
      },
    }
  }

</script>

<style>
  /* Add your custom styles here if needed */
</style>